// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2cXGO","boxTitle":"Qualiphy_boxTitle__2RUvA","box":"Qualiphy_box__28wZC","toggleWrap":"Qualiphy_toggleWrap__Evk49"};